import { Component } from '@angular/core';
import { SbCreateRoomDialogComponent } from '../sb-create-room-dialog/sb-create-room-dialog.component';
import { MatCard, MatCardContent } from '@angular/material/card';
import { RoomEmptyTestIds } from './sb-room-empty.test-ids';

@Component({
  selector: 'app-sb-room-empty',
  imports: [SbCreateRoomDialogComponent, MatCard, MatCardContent],
  templateUrl: './sb-room-empty.component.html',
  styleUrl: './sb-room-empty.component.scss'
})
/**
 * Darstellung eines leeren Raumes
 * Begründung: UX Anforderung
 */
export class SbRoomEmptyComponent {
  protected readonly testIds = RoomEmptyTestIds;
}
